import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AuthCard } from "@/components/auth/AuthCard";
import { ResetForm } from "@/components/auth/ResetForm";
import { supabase } from "@/lib/supabase";

export function ResetPasswordPage() {
  const [hasRecoveryToken, setHasRecoveryToken] = useState(false);
  const { t } = useTranslation("auth");

  useEffect(() => {
    // Supabase emits PASSWORD_RECOVERY when the user lands on this page
    // via a recovery-link click; the URL hash also contains the token.
    const { data: subscription } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") {
        setHasRecoveryToken(true);
      }
    });
    // Heuristic for the case where the event has already fired before
    // mount (e.g., navigation from email link straight into this page):
    // check the URL hash directly.
    if (window.location.hash.includes("type=recovery")) {
      setHasRecoveryToken(true);
    }
    return () => subscription.subscription.unsubscribe();
  }, []);

  return (
    <AuthCard
      title={
        hasRecoveryToken
          ? t("resetPassword.setTitle")
          : t("resetPassword.title")
      }
      description={
        hasRecoveryToken
          ? t("resetPassword.setDescription")
          : t("resetPassword.description")
      }
    >
      <ResetForm hasRecoveryToken={hasRecoveryToken} />
    </AuthCard>
  );
}
